export const features = {
    showInformeControlInforme: true,
}